import React, { useState, useEffect } from 'react';

const RescheduleModal = ({ isOpen, onClose, inspection, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    inspection_type: '',
    preferred_date: '',
    preferred_time: '',
    contact_person: '',
    contact_phone: '',
    seller_address: '',
    branch_location: '',
    city: '',
    special_instructions: ''
  });

  const [error, setError] = useState('');

  useEffect(() => {
    if (inspection) {
      setFormData({
        inspection_type: inspection.inspection_type || '',
        preferred_date: inspection.preferred_date || '',
        preferred_time: inspection.preferred_time || '',
        contact_person: inspection.contact_person || '',
        contact_phone: inspection.contact_phone || '',
        seller_address: inspection.seller_address || '',
        branch_location: inspection.branch_location || '',
        city: inspection.city || '',
        special_instructions: inspection.special_instructions || ''
      });
      setError('');
    }
  }, [inspection]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.preferred_date || !formData.preferred_time) {
      setError('Please select date and time');
      return;
    }

    try {
      await onSubmit(formData);
    } catch (err) {
      setError(err.message || 'Failed to reschedule inspection');
    }
  };

  if (!isOpen) return null;

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h2>Reschedule Inspection</h2>
          <button style={styles.closeButton} onClick={onClose}>✕</button>
        </div>

        {error && (
          <div style={styles.errorMessage}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label>Inspection Type</label>
            <select
              name="inspection_type"
              value={formData.inspection_type}
              onChange={handleChange}
              style={styles.input}
              required
            >
              <option value="">Select Type</option>
              <option value="home">Home Inspection</option>
              <option value="branch">Branch Inspection</option>
            </select>
          </div>

          <div style={styles.formRow}>
            <div style={styles.formGroup}>
              <label>Preferred Date</label>
              <input
                type="date"
                name="preferred_date"
                value={formData.preferred_date}
                onChange={handleChange}
                style={styles.input}
                required
              />
            </div>
            <div style={styles.formGroup}>
              <label>Preferred Time</label>
              <input
                type="time"
                name="preferred_time"
                value={formData.preferred_time}
                onChange={handleChange}
                style={styles.input}
                required
              />
            </div>
          </div>

          <div style={styles.formRow}>
            <div style={styles.formGroup}>
              <label>Contact Person</label>
              <input
                type="text"
                name="contact_person"
                value={formData.contact_person}
                onChange={handleChange}
                style={styles.input}
                placeholder="Your name"
                required
              />
            </div>
            <div style={styles.formGroup}>
              <label>Phone Number</label>
              <input
                type="tel"
                name="contact_phone"
                value={formData.contact_phone}
                onChange={handleChange}
                style={styles.input}
                placeholder="+91 XXXXX XXXXX"
                required
              />
            </div>
          </div>

          {formData.branch_location === '' && (
            <div style={styles.formGroup}>
              <label>Seller Address</label>
              <textarea
                name="seller_address"
                value={formData.seller_address}
                onChange={handleChange}
                style={{...styles.input, minHeight: '80px'}}
                placeholder="Enter your address"
                required
              />
            </div>
          )}

          {formData.seller_address === '' && (
            <div style={styles.formGroup}>
              <label>Branch Location</label>
              <input
                type="text"
                name="branch_location"
                value={formData.branch_location}
                onChange={handleChange}
                style={styles.input}
                placeholder="Select branch"
                required
              />
            </div>
          )}

          <div style={styles.formGroup}>
            <label>City</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter city"
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label>Special Instructions (Optional)</label>
            <textarea
              name="special_instructions"
              value={formData.special_instructions}
              onChange={handleChange}
              style={{...styles.input, minHeight: '80px'}}
              placeholder="Any special requests or instructions"
            />
          </div>

          <div style={styles.formActions}>
            <button
              type="submit"
              style={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Rescheduling...' : 'Reschedule Inspection'}
            </button>
            <button
              type="button"
              style={styles.cancelButtonModal}
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: '15px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '90vh',
    overflow: 'auto'
  },
  modalHeader: {
    padding: '20px',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer'
  },
  form: {
    padding: '20px'
  },
  formGroup: {
    marginBottom: '20px'
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px'
  },
  input: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '1rem',
    fontFamily: 'inherit'
  },
  radioGroup: {
    display: 'flex',
    gap: '20px',
    marginTop: '10px'
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer'
  },
  errorMessage: {
    padding: '15px 20px',
    backgroundColor: '#fee',
    color: '#d32f2f',
    borderBottom: '1px solid #e0e0e0'
  },
  formActions: {
    display: 'flex',
    gap: '10px',
    marginTop: '30px'
  },
  submitButton: {
    flex: 1,
    backgroundColor: '#003566',
    color: '#fff',
    padding: '12px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '1rem'
  },
  cancelButtonModal: {
    flex: 1,
    backgroundColor: '#e0e0e0',
    color: '#333',
    padding: '12px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '1rem'
  }
};

export default RescheduleModal;